import { SvgIcon, SvgIconProps } from "@material-ui/core";
import React, { CSSProperties } from "react";

export function PromoteIcon(props: SvgIconProps) {
  const st0: CSSProperties = {
    fill: "none",
    stroke: "currentcolor",
    strokeWidth: 1.0854,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
  };
  const st1: CSSProperties = {
    fill: "none",
    stroke: "currentcolor",
    strokeWidth: 1.0854,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
  };
  const st2: CSSProperties = {
    fill: "none",
    stroke: "currentcolor",
    strokeWidth: 1.0854,
    strokeMiterlimit: 10,
  };
  const st3: CSSProperties = {
    fill: "none",
    stroke: "currentcolor",
    strokeWidth: 0.9768,
    strokeMiterlimit: 10,
  };

  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <g>
        <polygon
          style={st0}
          points="14.77,3.52 0.59,14.26 1.26,16.05 19.14,16.05 	"
        />
        <line style={st1} x1="14.31" y1="2.13" x2="19.66" y2="17.21" />
        <polyline
          style={st0}
          points="1.99,13.2 3.01,16.05 3.91,19.87 4.56,21.87 7.04,21 6.43,19.21 6.43,16.05 	"
        />
        <line style={st1} x1="18.17" y1="4.9" x2="20.73" y2="2.13" />
        <line style={st1} x1="20.43" y1="12.1" x2="23.41" y2="13.02" />
        <line style={st1} x1="19.45" y1="8.45" x2="23.15" y2="7.11" />
        <polyline
          style={st2}
          points="4.03,16.05 15.96,15.88 15.96,14.93 12.62,5.15 16.32,16.05 	"
        />
        <polyline style={st3} points="2.26,12.72 2.26,13.66 2.85,15.59 	" />
      </g>
    </SvgIcon>
  );
}
